'use client';
'use strict';

var classes = {"day":"m-396ce5cb"};

module.exports = classes;
//# sourceMappingURL=Day.module.css.cjs.map
